require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-archdaily-recently-features-our-grange-residence.json") })
        }
      }, "path---journal-archdaily-recently-features-our-grange-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-archdaily-recently-features-our-grange-residence!./.cache/json/journal-archdaily-recently-features-our-grange-residence.json
// module id = 452
// module chunks = 231608221292675